import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Controller, useFormContext, useWatch} from 'react-hook-form'
import {UserProfessionalEcmScoreValidationSchema} from '../../types'
import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {calculateTrienniumPeriod, cogeapsCertificationToLabel} from '../../utils'
import {InputText} from '@/components/commons/input-text/InputText'
import {useTranslation} from '@/translations/i18n'
import {useEffect} from 'react'
import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const UserEcmScoreForm = () => {
    const {t} = useTranslation()
    const form = useFormContext<UserProfessionalEcmScoreValidationSchema>()
    const ecmScore = useWatch({control: form.control, name: 'ecmScore'})

    useEffect(() => {
        if (!ecmScore) {
            form.setValue('ecmScore', {
                period: calculateTrienniumPeriod(new Date()),
                score: undefined,
                cogeapsCertification: undefined
            })
        }
    }, [ecmScore])

    return (
        <Grid columns={6} fullWidth gap={4}>
            <GridItem spanColumn={2}>
                <Flexbox direction="column" gap={1.5}>
                    <Text size="textSm" weight="500" palette="neutral" shade="700">
                        {t('accesses:period')}
                    </Text>
                    <Text palette="neutral" shade="950" weight="500" size="textMd">
                        {t('users:triennium_period', {years: ecmScore?.period?.label})}
                    </Text>
                </Flexbox>
            </GridItem>
            <GridItem spanColumn={2}>
                <Controller
                    control={form.control}
                    name="ecmScore.score"
                    render={({field}) => (
                        <InputText
                            type="number"
                            label={t('commons:total')}
                            placeholder={t('users:credits')}
                            value={field.value ?? ''}
                            onChange={event => field.onChange(Number(event.target.value))}
                        />
                    )}
                />
            </GridItem>
            <GridItem spanColumn={2}>
                <Controller
                    control={form.control}
                    name="ecmScore.cogeapsCertification"
                    render={({field}) => (
                        <InputSelect
                            label="Certificazione Cogeaps"
                            value={field.value ?? undefined}
                            optionsMap={cogeapsCertificationToLabel}
                            onChange={value => field.onChange(value)}
                        />
                    )}
                />
            </GridItem>
        </Grid>
    )
}
